var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMobileMenuWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2736_12841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.25H21.75C22.125 5.25 22.5 4.92188 22.5 4.54688C22.5 4.17188 22.125 3.75 21.75 3.75H2.25C1.82812 3.75 1.5 4.125 1.5 4.5C1.5 4.875 1.82812 5.25 2.25 5.25ZM21.75 11.25H2.25C1.82812 11.25 1.5 11.625 1.5 12C1.5 12.4219 1.82812 12.75 2.25 12.75H21.75C22.125 12.75 22.5 12.4219 22.5 12C22.5 11.625 22.125 11.25 21.75 11.25ZM21.75 18.75H2.25C1.82812 18.75 1.5 19.125 1.5 19.5C1.5 19.875 1.82812 20.25 2.25 20.25H21.75C22.125 20.25 22.5 19.9219 22.5 19.5469C22.5 19.1719 22.125 18.75 21.75 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2736_12841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileMenuWhite);
export default __webpack_public_path__ + "static/media/Icon_MobileMenu_White.dd05aee795fcd0c85cf05f4b5c737919.svg";
export { ForwardRef as ReactComponent };